import React from 'react'
import PropTypes from 'prop-types'

import Checkbox from 'material-ui/Checkbox'
import deleteIcon from 'resources/imported_calendar_delete.png'

export default class ReportEmail extends React.Component {

  static propTypes = {
    style: PropTypes.object.isRequired,
    entry: PropTypes.object.isRequired,
    onRemoveClicked: PropTypes.func.isRequired,
    onEntryCheck: PropTypes.func.isRequired
  }

  render() {
    return (
      <div style={{ ...this.props.style, ...styles.container }}>
        <div style={styles.left}>
          <Checkbox
            style={{ width: 24 }}
            iconStyle={{ fill: '#8c8c8c' }}
            onCheck={this.props.onEntryCheck}
            checked={!this.props.entry.disabled} />
          <div style={styles.address}>{ this.props.entry.address }</div>
        </div>
        <div style={styles.right}>
          <img src={deleteIcon} title='Remove' width={18} onClick={this.props.onRemoveClicked} style={{ cursor: 'pointer' }} />
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#f6f6f6',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 350,
    height: 32,
    paddingRight: 8,
    paddingLeft: 8
  },
  left: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'    
  },
  address: {
    fontWeight: 300,
    marginLeft: 10    
  },
  right: {
    height: 18
  }
}



// WEBPACK FOOTER //
// ./src/settings/modules/dailyEmails/ReportEmail.js